/** Qué está haciendo el asistente ahora mismo, para el indicador de estado. */
export type ActivityType = { state: 'idle' } | { state: 'thinking' } | { state: 'tool'; name: string }

/** A un usuario no le dice nada "consultar_servicios". */
const TOOL_LABELS: Record<string, string> = {
  consultar_servicios: 'Consultando los servicios',
  registrar_lead: 'Guardando tus datos de contacto',
  get_server_datetime: 'Consultando la fecha',
  consultar_bd: 'Consultando la base de datos'
}

export const toolLabel = (name: string) => TOOL_LABELS[name] ?? `Usando ${name.replace(/_/g, ' ')}`

export function activityLabel(activity: ActivityType): string {
  if (activity.state === 'tool') return `${toolLabel(activity.name)}…`
  if (activity.state === 'thinking') return 'Pensando…'
  return ''
}
